export class AwsNetworkingSettings {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vpcPeering",
            "baseName": "vpcPeering",
            "type": "AwsNetworkingSettingsVpcPeering",
            "format": ""
        },
        {
            "name": "privateLinks",
            "baseName": "privateLinks",
            "type": "Array<AwsPrivateLink>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsNetworkingSettings.attributeTypeMap;
    }
    constructor() {
    }
}
